const namespaceNotification = '[NOTIFICATION]';

export const NOTIFICATION_GET_SUCCESS = `${namespaceNotification} GET SUCCESS`;
export const NOTIFICATION_READ = `${namespaceNotification} READ`;
